import { render, staticRenderFns } from "./Goodlist.vue?vue&type=template&id=394aa306&scoped=true&"
import script from "./Goodlist.vue?vue&type=script&lang=js&"
export * from "./Goodlist.vue?vue&type=script&lang=js&"
import style0 from "./Goodlist.vue?vue&type=style&index=0&id=394aa306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394aa306",
  null
  
)

export default component.exports